import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {};

export const badge: SxStyle = {
  background: (p) => p.palette.primary[100],
  color: (p) => p.palette.primary[500],
};

export const box: SxStyle = {
  background: (p) => p.palette.grey[200],
  borderRadius: (p) => p.spacing(0.5),
  width: (p) => p.spacing(2),
  height: (p) => p.spacing(2),
  cursor: 'pointer',
};
